import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'src/store';
import './BacktestingLoader.css';

const BacktestingLoader: React.FC = observer(() => {
    const { replayController } = useStores();

    if (!replayController.isLoadingReplay) return null;

    return (
        <div className="backtesting-loader-overlay">
            <div className="backtesting-loader-content">
                <div className="backtesting-loader-spinner">
                    <div className="backtesting-loader-ring" />
                    <div className="backtesting-loader-ring backtesting-loader-ring--delayed" />
                </div>
                <div className="backtesting-loader-text">Loading chart data&hellip;</div>
                <div className="backtesting-loader-subtext">Fetching historical candles for replay</div>
            </div>
        </div>
    );
});

export default BacktestingLoader;
